export default __webpack_public_path__ + "static/media/nw.e2fe7a45.png";